/**
 * SmoothScrolljs
 * File for smooth scroll effect in anchor links
 */

jQuery(document).ready(function($) {
    $('a[href*="#"]:not([href="#"])').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            let target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top -80
                }, 600);
                return false;
            }
        }
    });
});
